import { useTranslation } from "react-i18next";

import s1 from '../../img/About/s1.png';
import i1 from '../../img/About/ss1.png';
import i2 from '../../img/About/ss2.png';

function MoneyWork () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative mt-[100px] xl:mt-[140px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
                <p className="text-[20px] xl:text-[32px] manrope leading-[1.2] font-[500] text-black xl:max-w-[497px]">{t('about.10')}</p>
                <div className="mt-[40px] xl:mt-[60px]">
                    <div className="flex flex-col xl:flex-row gap-[12px] xl:gap-[20px] xl:h-[280px]">
                        <div className="relative flex-shrink-0">
                            <img src={s1} alt="" className="h-[156px] w-full xl:h-auto object-cover rounded-[20px]"/>
                            <div className="absolute bottom-[30px] xl:bottom-[40px] left-[20px] xl:left-[30px]">
                                <p className="text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('about.11')}</p>
                                <p className="roboto text-[12px] xl:text-[14px] font-[300] mt-[16px] text-[#FFFFFFB2] xl:max-w-[438px]">{t('about.12')}</p>
                            </div>
                        </div>
                        <div className="bg-[#131313] rounded-[20px] w-full h-[170px] xl:h-auto relative">
                            <img src={i1} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px] mt-[20px] mx-[20px] xl:mx-[40px]" alt="" />\
                            <div className="absolute bottom-[20px] xl:bottom-[50px] left-[20px] xl:left-[30px]">
                                <p className="text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('about.13')}</p>
                                <p className="roboto text-[12px] xl:text-[14px] font-[300] mt-[16px] text-[#FFFFFFB2] max-w-[235px]">{t('about.14')}</p>
                            </div>
                        </div>
                        <div className="bg-[#131313] rounded-[20px] w-full h-[170px] xl:h-auto relative">
                            <img src={i2} className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px] mt-[20px] mx-[20px] xl:mx-[40px]" alt="" />\
                            <div className="absolute bottom-[20px] xl:bottom-[40px] left-[20px] xl:left-[30px]">
                                <p className="text-white manrope text-[16px] xl:text-[20px] font-[500]">{t('about.15')}</p>
                                <p className="roboto text-[12px] xl:text-[14px] font-[300] mt-[16px] text-[#FFFFFFB2] max-w-[235px]">{t('about.16')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MoneyWork;